const columns = [
  {
    title: '内容形态',
    links: ['事件始末', '时间线', '全过程梳理', '深度解析', '热度榜单'],
  },
  {
    title: '热门分区',
    links: ['娱乐动态', '网红主播', '品牌商业', '文娱演出', '综艺话题'],
  },
  {
    title: '关于本站',
    links: ['内容说明', '核实原则', '纠错反馈', '更新日志', '联系我们'],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-5 lg:gap-10">
          <div className="lg:col-span-2">
            <a href="#top" className="flex cursor-pointer items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-eye-2-line text-2xl" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black text-foreground-950">黑料爆料</span>
                <span className="mt-1 text-[10px] tracking-[0.28em] text-foreground-500">EVENT ARCHIVE</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              黑料爆料专注于把热门事件的来龙去脉按阶段整理清楚：从起因、发酵到回应与后续，用时间线和全过程梳理帮你一次看清前因后果。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-mail-line', 'ri-rss-line'].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  aria-label="社交渠道"
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-400 bg-background-100 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  <i className={`${icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="font-heading text-sm font-bold text-foreground-950">{column.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link}>
                    <a href="#top" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-background-400 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-relaxed text-foreground-500">
            本站内容整理自公开信息，仅作事件梳理与阅读参考，涉及的具体说法请以当事方正式说明为准。
          </p>
          <p className="shrink-0 text-xs text-foreground-500">© 2026 黑料爆料 · 保留所有权利</p>
        </div>
      </div>
    </footer>
  );
}